import React from 'react';
import { Box, Heading, Text, VStack, useColorModeValue } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { capitalizeFirstLetter } from '../../utils/utils';

function ProfilePage() {
    const user = useSelector(state => state.userState.user);

    return (
        <Box p={4} bg={useColorModeValue('white', 'gray.800')} rounded="md" shadow="sm">
            <Heading size="md" mb={6}>Profile Details</Heading>
            <VStack align="start" spacing={4}>
                <Box>
                    <Text fontWeight="bold">Name:</Text>
                    <Text>{user && user.displayName ? capitalizeFirstLetter(user.displayName) : 'Admin'}</Text>
                </Box>
                <Box>
                    <Text fontWeight="bold">Email:</Text>
                    <Text>{user?.email || user?.username}</Text>
                </Box>
                <Box>
                    <Text fontWeight="bold">Role:</Text>
                    <Text>Admin</Text>
                </Box>
            </VStack>
        </Box>
    );
}

export default ProfilePage;
